import gql from 'graphql-tag'

export const GET_EMPLOYERS = gql`

query(
  $page:Int
  $perPage:Int
  $search:String
)
{ 
employerList(page:$page perPage:$perPage search:$search){
  _id
  companyName
  appliedEmails
  nortificationEmails
  notifyExpire
  point
  blacklist
  grayStatus
  darkGrayStatus
  yellowStatus
	orderedBy{
			isOwner
			email
		}
}
}


`

export const GET_EMP_BY_ID = gql` 
query(
  $id:ID
)
{ 
  getEmpById(id:$id){
  _id
  companyName
  appliedEmails
  nortificationEmails
  notifyExpire
  point
  blacklist
  grayStatus
  darkGrayStatus
  yellowStatus
	orderedBy{
			isOwner
			email
		}
}
}
`